export default function useCurrentLocale() {
    const url = window.location.href;
    const splitUrl = url.split('/');
    return splitUrl[3] || 'en';
}